import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-715287a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "bold-h3" }, "Recuperar senha", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "informative-form regular-p" }, " Escolha uma nova senha para acessar seu perfil ", -1))
const _hoisted_8 = { class: "lcts-button mt-5" }
const _hoisted_9 = { class: "informative-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "informative-item-1 regular-p" }, "Não possui conta? ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cadastre-se", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginCarousel = _resolveComponent("LoginCarousel")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoginCarousel)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("form", null, [
          _createVNode(_component_Password, {
            isRegister: true,
            isConfirm: true,
            isReset: true,
            onValuePasswordChange: _ctx.handleInputNewPasswordValue,
            onValidPassword: _ctx.handleInputPasswordIsValid
          }, null, 8, ["onValuePasswordChange", "onValidPassword"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              onLctsButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleButtonClick(_ctx.form))),
              size: "large",
              disabled: !_ctx.isPasswordValid,
              styleButton: "secondary",
              text: "Alterar senha",
              width: "100%"
            }, null, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_RouterLink, {
            to: { name: 'register' },
            class: "informative-item-2 bold-p"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}